
@if (templateName) {
<div class="template-wrap hidden-print hidden-xs ft-template-name text-ellipsis  mat-title" title="{{templateName}}">
    {{templateName}}
</div>
}

